module.exports = __webpack_public_path__ + "img/belotserkovskiy.d1f4e5a5.jpg";